// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/sigmet-airmet-criteria.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/sigmet-airmet-criteria/sigmet-airmet-criteria.js';

mount([g0]);
